import React from "react";
import { Field } from "react-final-form";
import { CentsInput } from "../../../components/inputs/final_form/MoneyInput";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { required } from "../../../util/validators";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const FeeScheduleByTestForm = ({ handleSubmit, submitting, create = true }) => {
  return (
    <>
      <Field component={TextInput} type="hidden" name="labId" />

      {create && (
        <>
          <Field
            component={AdminOptionableInput}
            resource="payors"
            label="Payor"
            name="payorId"
            searchParam="name"
            required
            validate={required}
          />
          <Field
            component={AdministrateSelectInput}
            resourceUrl="/admin/tests.json"
            label="Test"
            name="testId"
            required
            validate={required}
          />
        </>
      )}
      <Field component={CentsInput} validate={required} label="Price" name="priceCents" />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
